var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DialogRestHome',{ref:"rest-home-dialog",attrs:{"title":"Adicionar ILPI","rest-home":{}},on:{"submited":_vm.createRestHome,"close":function () { return _vm.$emit('close'); }}})}
var staticRenderFns = []

export { render, staticRenderFns }